import { render, staticRenderFns } from "./EditItemPicker.vue?vue&type=template&id=01d71a13&"
import script from "./EditItemPicker.vue?vue&type=script&lang=js&"
export * from "./EditItemPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports